import React, { useEffect } from "react";
import {
  useResolvedPath,
  useMatch,
  NavLink,
  useLocation,
  matchPath,
} from "react-router-dom";
import menusCGM from "./../../config/app-menu-cgm.jsx";
import menusCMMS from "./../../config/app-menu-cmms.jsx";
import { useDashboardContext } from "../../contexts/NewDashboardContext.jsx";
import { useAuth } from "../../contexts/AuthContext";

function NavItem({ menu, ...props }) {
  let path = menu.path ? menu.path : "";
  let resolved = useResolvedPath(path);
  let match = useMatch({ path: resolved.pathname });
  let location = useLocation();

  if (menu.is_header) {
    return <div className="menu-header">{menu.title}</div>;
  }

  if (menu.is_divider) {
    return <div className="menu-divider"></div>;
  }

  let match2 = matchPath({ path: path, end: false }, location.pathname);

  let icon = menu.icon && (
    <div className="menu-icon">
      <i className={menu.icon}></i>
    </div>
  );
  let img = menu.img && (
    <div className="menu-icon-img">
      <img src={menu.img} alt="" />
    </div>
  );
  let caret = menu.children && !menu.badge && (
    <div className="menu-caret">
      <b className="caret"></b>
    </div>
  );
  let label = menu.label && (
    <span className="menu-label ms-5px">{menu.label}</span>
  );
  let badge = menu.badge && <div className="menu-badge">{menu.badge}</div>;
  let highlight = menu.highlight && (
    <i className="fa fa-paper-plane text-theme"></i>
  );
  let title = menu.title && (
    <div className="menu-text">
      {menu.title} {label} {highlight}
    </div>
  );

  return (
    <div
      className={
        "menu-item" +
        (match || match2 ? " active" : "") +
        (menu.children ? " has-sub" : "")
      }
    >
      <NavLink className="menu-link" to={menu.path} {...props}>
        {img} {icon} {title}
        {caret} {badge}
      </NavLink>

      {menu.children && (
        <div className="menu-submenu">
          {menu.children.map((submenu, i) => (
            <NavItem key={i} menu={submenu} />
          ))}
        </div>
      )}
    </div>
  );
}

function SidebarNav() {
  const { config } = useAuth();
  const { selectedApp, userSetupCenter } = useDashboardContext();
  const [filteredMenuCMMS, setFilteredMenuCMMS] = React.useState(menusCMMS);
  const [filteredMenuCGM, setFilteredMenuCGM] = React.useState([]);
  const allSetup = ["asset", "work order", "team", "assign"];
  useEffect(() => {
    if (userSetupCenter) {
      // example userSetupCenter it is a string "asset,team"
      // make it an array if all setup are available in userSetupCenter then the result is true
      const userSetup = userSetupCenter.split(",");
      const result = allSetup.every((val) => userSetup.includes(val));
      if (result) {
        // if all setup are available remova  path: "/setup-center" in the menu
        setFilteredMenuCMMS(
          menusCMMS.filter((menu) => menu.path !== "/setup-center")
        );
      }
    }
  }, [userSetupCenter]);

  useEffect(() => {
    if (menusCGM) {
      // replace Machines text into Assets
      let newMenusCGM = menusCGM;

      // add children to path: "/machine/list"
      if (config?.is_matar) {
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/machine/list");
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/dashboard");
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/machine-health");
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/alarm/list");
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/report/export");
        newMenusCGM.map((menu) => {
          menu.title = menu.title.replace("Machine", "Asset");

          // replace the children text
          if (menu.children) {
            menu.children.map((child) => {
              child.title = child.title.replace("Machine", "Asset");
            });
          }
        });
        newMenusCGM.map((menu) => {
          if (menu.path === "/machine/list") {
            menu.children = [
              ...menu.children,
              {
                path: "/machine-asset/condition",
                title: "Asset Condition",
              },
              {
                path: "/machine-asset/replacement",
                title: "Asset Replacement",
              },
              {
                path: "/machine-asset/rul",
                title: "Asset RUL",
              },
              {
                path: "/machine-asset/work-order",
                title: "Asset Work Order & Failure",
              },
            ];
          }
        });

        let newConfiguration = newMenusCGM.find(
          (i) => i.path === "/configuration"
        );
        const newConfigurationChilder = newConfiguration.children.filter(
          (i) => i.path !== "/configuration/roles"
        );
        newConfiguration.children = newConfigurationChilder;
      } else {
        newMenusCGM = newMenusCGM.filter(
          (i) => i.path !== "/machine-asset/asset-list"
        );
        newMenusCGM = newMenusCGM.filter(
          (i) => i.path !== "/machine-asset/financial-strategies"
        );
        let newConfiguration = newMenusCGM.find(
          (i) => i.path === "/configuration"
        );
        const newConfigurationChilder = newConfiguration.children.filter(
          (i) => i.path !== "/configuration/group"
        );
        newConfiguration.children = newConfigurationChilder;
        newMenusCGM = newMenusCGM.filter((i) => i.path !== "/matar-dashboard");
        newMenusCGM = newMenusCGM.filter(
          (i) => i.path !== "/machine-asset/investment-list"
        );
      }

      setFilteredMenuCGM(newMenusCGM);
    }
  }, [menusCGM]);

  return (
    <div className="menu">
      {selectedApp == "CGM" &&
        filteredMenuCGM.map((menu, i) => <NavItem key={i} menu={menu} />)}
      {selectedApp == "CMMS" &&
        filteredMenuCMMS.map((menu, i) => <NavItem key={i} menu={menu} />)}
    </div>
  );
}

export default SidebarNav;
